import { createUseStyles } from 'react-jss';

import { MD_MEDIA_QUERY } from '~shared/media-query';
import { PricingAppTheme } from '~app/styles/pricing/types';

export default createUseStyles(({ spacing, type, pricingPalette }: PricingAppTheme) => ({
  Highlight: {
    backgroundColor: pricingPalette.colors.canvas,
  },
  Features: {
    listStyle: 'none',
    fontSize: 13,
    lineHeight: 1.2,
    color: pricingPalette.colors.charcoal,
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    margin: [20, 'auto', 30],
    width: '100%',
    [MD_MEDIA_QUERY]: {
      margin: [20, 0, 30],
    },
  },
  FeatureItem: {
    position: 'relative',
    padding: [spacing[1], '20%', spacing[1]],
    display: 'flex',
    alignItems: 'center',
    wordBreak: 'break-word',
    '&:before': {
      content: '"•"',
      display: 'inline-block',
      paddingRight: 10,
      color: pricingPalette.colors.stone,
      fontSize: 20,
    },
    [MD_MEDIA_QUERY]: {
      padding: `${spacing[1]}px ${spacing[7]}px ${spacing[1]}px ${spacing[6]}px`,
      '&:hover': {
        extend: 'Highlight',
        transition: '0.2s ease',
      },
    },
  },
  FeatureSummary: {
    lineHeight: 1.6,
    [MD_MEDIA_QUERY]: {
      '&:hover': {
        '& $TooltipContainer': {
          display: 'inline-block',
        },
      },
    },
  },
  TooltipContainer: {
    display: 'none',
  },
}));
